export const LogoImg = ({ className = "h-9 w-auto" }) => (
    <img src="/logo.png" alt="Amor Sin Aviso — Marbella" className={className} />
);
